module.exports = "0.38.1";



//////////////////
// WEBPACK FOOTER
// ./~/autocomplete.js/version.js
// module id = 89
// module chunks = 0